import { domain } from 'modules/data';
import { NetSuiteMatchingLine } from 'shared/hooks/(matchings)';

import { NetSuiteSourceMatchingLine } from './NetSuiteMatchingPopup.types';

export const isLineMatchingDisabled = (
    line: NetSuiteMatchingLine,
    lineType: domain.NetSuiteMatchingLineType | undefined,
    sourceLine: NetSuiteSourceMatchingLine | null
) => {
    if (!lineType || !sourceLine) {
        return true;
    }

    if (lineType === domain.NetSuiteMatchingLineType.Expense) {
        return line.isMatched;
    }

    return (
        !line.quantity || line.quantity < (line.billed ?? 0) + ('quantity' in sourceLine ? sourceLine.quantity ?? 0 : 0)
    );
};
